import { render, staticRenderFns } from "./sqlTable.vue?vue&type=template&id=016c46b8&"
import script from "./sqlTable.vue?vue&type=script&lang=js&"
export * from "./sqlTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports